export default __webpack_public_path__ + "img/circle-medium.e5b6315a.svg";